import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

const FOCUSABLE_SELECTOR =
  'input, textarea, select, [tabindex]:not([tabindex="-1"])';

/**
 * Directive to automatically focus the first focusable element within the host.
 * Usage: <input pAutoFocus="true" />
 */
@Directive({
  selector: '[pAutoFocus]',
})
export class PAutoFocusDirective {
  @Input() set pAutoFocus(shouldFocus: boolean) {
    if (shouldFocus) {
      this.triggerAutoFocus();
    }
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  public triggerAutoFocus(): void {
    setTimeout(() => {
      const focusable: HTMLElement | null = this.elementRef.nativeElement.querySelector(
        FOCUSABLE_SELECTOR
      );

      if (focusable) {
        this.renderer.selectRootElement(focusable).focus();
        console.debug(
          'PAutoFocusDirective: Focus triggered on focusable child element.'
        );
      } else {
        this.renderer.selectRootElement(this.elementRef.nativeElement).focus();
        console.debug('PAutoFocusDirective: Focus triggered on host element.');
      }
    }, 500);
  }
}
